import { Text, View, ViewStyle } from "react-native";
import { Dropdown } from "../../components";
import { Controller, Control } from "react-hook-form";
import { JobPreferenceField, JobPreferencesFormData } from "./types";

interface JobSearchStatusProps {
  control: Control<JobPreferencesFormData>;
  searchStatuses: JobPreferenceField[];
  style?: ViewStyle;
}

const JobSearchStatus = ({ control, searchStatuses, style }: JobSearchStatusProps) => {
  return (
    <View className="bg-white px-6 py-8" {...{ style }}>
      <Text className="text-large-normal text-ink-darkest font-700 mb-6">Where are you in your search?</Text>
      <View className="mb-4">
        <Controller
          name="jobSearchStatus"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Dropdown
              {...{
                placeholder: "Select",
                list: searchStatuses,
                setValue: onChange,
                value,
              }}
            />
          )}
        />
      </View>
      <Text className="text-small-normal text-ink-lighter">
        Your responses are strictly confidential and will only be used by PGA Career Consultants to better serve you.
      </Text>
    </View>
  );
};

export default JobSearchStatus;
